export const SAVE_ALL_FINANCIAL_CATEGORIES = 'SAVE_ALL_FINANCIAL_CATEGORIES'